import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { PriceChangeService } from "../services/price-change.resource";
import { ActivatedRoute } from "@angular/router";
import { PriceChangeLabel } from "../models/price-change.model";
import { PriceExplorerDatetimeDialog } from "./dialogs/price-explorer-datetime-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { SnackbarService } from "../../../utils/shared-services/snackbar/snackbar.service";
import { CaptionService } from "../../../utils/shared-services/caption.service";
import { FormBuilder } from "@angular/forms";
import { ConfirmCancelDialogComponent } from "./dialogs/confirm-cancel-dialog.component";
import { SelectionModel } from "@angular/cdk/collections";


@Component({
    selector: "app-price-explorer",
    templateUrl: "./src/app/features/price-change/templates/price-explorer.component.html",
    standalone: false
})
export class PriceExplorerComponent implements OnInit {

    private formBuilder: FormBuilder = new FormBuilder();
    priceChangeLabels: PriceChangeLabel[] = [];
    conceptID: number;
    selectedLabel: PriceChangeLabel | null = null;
    minDate: Date = new Date();
    maxDate: Date = new Date();
    isAllDates: boolean = false;
    storeRecords: any[] = [];
    captions: Record<string, string> = {};
    public formGroup = this.formBuilder.group({
        startDate: [new Date()],
        endDate: [new Date()],
    });
    labelSearch = '';
    filteredLabels: PriceChangeLabel[] = [];

    selection = new SelectionModel<any>(true, []); // true = multi-select
    constructor(@Inject(PriceChangeService) private priceChangeService: PriceChangeService,
        @Inject(ActivatedRoute) private actRoute: ActivatedRoute,
        @Inject(SnackbarService) private snackbarService: SnackbarService,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(CaptionService) private captionService: CaptionService,
        @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef
    ) {
        this.captions = this.captionService.captions;
    }


    ngOnInit(): void {
        this.actRoute.params.subscribe(params => {
            this.conceptID = +params['pathId'];
        });
    }

    onSelectLabel(label: PriceChangeLabel) {
        this.selectedLabel = label;
        this.priceChangeService.getStorePriceChangeLabel(this.conceptID, this.selectedLabel.displayName).then(storeRecords => {
            this.storeRecords = storeRecords;
        });
    }

    onReschedule(record: any) {
        const selected = this.selection.selected;

        const dialogRef = this.dialog.open(PriceExplorerDatetimeDialog, {
            panelClass: 'app-full-bleed-dialog',
            maxWidth: '95vw',
            minWidth: '25%',
            data: {
                when2Execute: record.When2Execute,
                label: record.Label,
                storeRecordsLength: this.storeRecords.length,
                conceptID: this.conceptID,
                recordsSelected: 1
            },
        });
        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                let storeIdPosToDoIdArray: { StoreID: any; PosToDoID: any; }[]
                if (selected.length > 0) {
                    storeIdPosToDoIdArray = selected.map(record => ({
                        StoreID: record.StoreID,
                        PosToDoID: record.PosToDoID
                    }));
                } else {
                    // one record reschedule button was clicked, not selected via checkbox
                    storeIdPosToDoIdArray = [{ StoreID: record.StoreID, PosToDoID: record.PosToDoID }];
                }
                const labelObj = {
                    conceptID: this.conceptID,
                    displayName: result.label,
                    when2Execute: result.when2Execute
                };

                this.priceChangeService.reschedulePriceChangeWithNewLabel(
                    result.when2Execute,
                    labelObj,
                    this.conceptID,
                    storeIdPosToDoIdArray
                ).then(response => {
                    this.snackbarService.successMessageTop(response);
                    this.priceChangeService.getPriceChangeLabels(this.conceptID).then(labels => {
                        this.priceChangeLabels = labels;
                    });
                    this.priceChangeService.getStorePriceChangeLabel(this.conceptID, this.selectedLabel.displayName).then(storeRecords => {
                        this.storeRecords = storeRecords;
                        this.selection.clear();
                    });
                });
            }
        });
    }

    onDateChange(dateType: string) {
        if (dateType === 'all') {
            this.priceChangeService.getPriceChangeLabels(this.conceptID).then(labels => {
                this.priceChangeLabels = labels;
                this.filteredLabels = [...labels];
            console.log("labels by date", this.filteredLabels);
            this.cdr.detectChanges();
            });
        } else if (dateType === 'dateRange') {
            this.priceChangeLabels = []
            // Reset the date range to today's date
            const today = new Date();
            this.formGroup.get('startDate').setValue(today);
            this.formGroup.get('endDate').setValue(today);
        }

    }

    submitDate() {
        this.isAllDates = false;
        let startDate = this.formatDateYMD(this.formGroup.get('startDate').value);
        let endDate = this.formatDateYMD(this.formGroup.get('endDate').value);
        //fix for case when startDate is selected but endDate is not
        if (startDate && !endDate) {
            this.formGroup.get('endDate').setValue(this.formGroup.get('startDate').value)
            endDate = startDate;
        }
        this.priceChangeService.getPriceChangeLabelsByDates(this.conceptID, startDate, endDate).then(labels => {
            this.priceChangeLabels = labels;
           this.filteredLabels = [...labels];
            console.log("labels by date", this.filteredLabels);
            this.cdr.detectChanges();
        });
    }

    onCancel(records: any | any[]) {
        const recordsArray = Array.isArray(records) ? records : [records];

        const dialogRef = this.dialog.open(ConfirmCancelDialogComponent, {
            panelClass: 'app-full-bleed-dialog',
            maxWidth: '95vw',
            minWidth: '25%',

        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                Promise.all(
                    records.map(record =>
                        this.priceChangeService.cancelPriceChange(record.StoreID, record.PosToDoID, record.Label)
                    )
                ).then(responses => {
                    this.snackbarService.successMessageTop("Successfully cancelled price change for selected records.");
                    this.priceChangeService.getStorePriceChangeLabel(this.conceptID, this.selectedLabel.displayName).then(storeRecords => {
                        this.storeRecords = storeRecords;
                        this.selection.clear(); // Clear selection after batch action
                    });
                });
            }
        });


    }

    formatDateYMD(date: Date): string {
        return date ? date.toISOString().slice(0, 10) : '';
    }

    // Batch actions
    onBatchCancel() {
        const selected = this.selection.selected;

        if (selected.length > 0) {
            this.onCancel(selected);
        }
    }

    onBatchReschedule() {
        const selected = this.selection.selected;

        if (selected.length > 0) {
            const dialogRef = this.dialog.open(PriceExplorerDatetimeDialog, {
                panelClass: 'app-full-bleed-dialog',
                maxWidth: '95vw',
                minWidth: '25%',
                data: {
                    when2Execute: selected[0].When2Execute, // Use the first record's date as default
                    label: selected[0].Label,
                    storeRecordsLength: this.storeRecords.length,
                    conceptID: this.conceptID,
                    recordsSelected: selected.length,
                },
            });

            dialogRef.afterClosed().subscribe((result: any) => {
                if (result) {
                    if (result.label) {
                        // Call the service with new label for all selected stores
                        const storeIdPosToDoIdArray = selected.map(record => ({
                            StoreID: record.StoreID,
                            PosToDoID: record.PosToDoID
                        }));

                        const labelObj = {
                            conceptID: this.conceptID,
                            displayName: result.label,
                            when2Execute: result.when2Execute
                        };

                        this.priceChangeService.reschedulePriceChangeWithNewLabel(
                            result.when2Execute,
                            labelObj,
                            this.conceptID,
                            storeIdPosToDoIdArray
                        ).then(response => {
                            this.snackbarService.successMessageTop("Successfully rescheduled selected records with new label.");
                            this.priceChangeService.getPriceChangeLabels(this.conceptID).then(labels => {
                                this.priceChangeLabels = labels;
                            });
                            this.priceChangeService.getStorePriceChangeLabel(this.conceptID, this.selectedLabel.displayName).then(storeRecords => {
                                this.storeRecords = storeRecords;
                                this.selection.clear();
                            });
                        });
                    } else {
                        // Regular batch reschedule
                        Promise.all(
                            selected.map(record =>
                                this.priceChangeService.reschedulePriceChange(record.StoreID, record.PosToDoID, result.when2Execute)
                            )
                        ).then(responses => {
                            this.snackbarService.successMessageTop("Successfully rescheduled selected records.");
                            this.priceChangeService.getPriceChangeLabels(this.conceptID).then(labels => {
                                this.priceChangeLabels = labels;
                            });
                            this.priceChangeService.getStorePriceChangeLabel(this.conceptID, this.selectedLabel.displayName).then(storeRecords => {
                                this.storeRecords = storeRecords;
                                this.selection.clear();
                            });
                        });
                    }
                }
                // If result is false or dialog closed, do nothing
            });

        }
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.storeRecords.length;
        return numSelected === numRows;
    }

    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.storeRecords.forEach(row => this.selection.select(row));
    }

    applyFilter() {
        const search = this.labelSearch?.toLowerCase()?.trim();

        if (!search) {
            this.filteredLabels = [...this.priceChangeLabels];
            return;
        }

        this.filteredLabels = this.priceChangeLabels.filter(label =>
            label.displayName.toLowerCase().includes(search)
        );
    }


}